var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSelectArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.438,
    height: 9.133
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 367",
    d: "M.707 8.426l7.012-7.012 7.012 7.012",
    fill: "none",
    stroke: "#333",
    strokeWidth: 2
  })));
}

export default __webpack_public_path__ + "af12012180f17cb15c081e8255da89f9.svg";
export { SvgSelectArrowUp as ReactComponent };